var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.25L2.25 5.25V3.75H15.75V5.25Z",
    fill: "black",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.75H3.75V8.25H14.25V9.75Z",
    fill: "black",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.25H12V12.75H6V14.25Z",
    fill: "black",
    fillOpacity: 0.76
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ceb6b8ed1776551b8ec2642158d7d3f3.svg";
export { ForwardRef as ReactComponent };